module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGPIyc76TwlmGDVg1IBRA4aLAQBsj0Af1AC28AAAAABJRU5ErkJggg=="